import {inject, Injectable, Injector} from '@angular/core';
import {PaymentMethod} from '@features/payment/domain/model/payment.model';
import {
  RefundStrategy,
  RefundStrategyRegistry
} from '@features/payment/domain/ports/strategy/refund-strategy.port';
import {InvoiceRefundStrategy} from '../strategies/refund/invoice-refund.strategy';
import {WalletRefundStrategy} from '../strategies/refund/wallet-refund.strategy';

@Injectable({providedIn: 'root'})
export class InfrastructureRefundStrategyRegistry implements RefundStrategyRegistry {
  private readonly injector = inject(Injector);

  resolve(method: PaymentMethod): RefundStrategy {
    const strategy = method === PaymentMethod.WALLET ? WalletRefundStrategy : InvoiceRefundStrategy;
    
    return this.injector.get(strategy);
  }
}
